import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PARTNER_MANAGEMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/partner-management',
        name: '::Menu:PartnerManagement',
        parentName: 'AbpIdentity::Menu:IdentityManagement',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.PartnerManagement',
      },
    ]);
  };
}
